import axios from 'axios';
import router from '../router'
// var qs = require('qs');
import qs from 'qs'

let baseUrl = process.env.API_ROOT

export default async(data = {}, method = 'GET', contentType = 'application/x-www-form-urlencoded; charset=utf-8') => {
    method = method.toUpperCase();
    let url = baseUrl + '/php/manager.php';

    // axios参数配置
    let requestConfig = {
        method: method,
        url: url,
        headers: {
            'Content-Type': contentType
        },
    }


    //添加参数
    if (method == 'GET') {
        Object.defineProperty(requestConfig, 'params', {
            value: data,
            enumerable: true
        })
    } else {
        Object.defineProperty(requestConfig, 'data', {
            value: qs.stringify(data),
            enumerable: true
        })
    }


    // 用axios发起ajax请求
    return new Promise((resolve, reject) => {
        axios(requestConfig).then((res) => {
            resolve(res);
        }).catch((error) => {
            reject(error);
        })
    })

}

// axios请求拦截器
axios.interceptors.request.use(function(config) {
        // 在发送请求之前做些什么
        if (config.method == "GET") {
            // 请求参数自动加时间戳
            config.params.timestamp = (new Date()).getTime();
        }

        return config;

    },
    function(error) {
        // 对请求错误做些什么
        if (axios.isCancel(error)) {
            console.log('Request canceled', error.message);
        } else {
            // 处理错误
        }
        return Promise.reject(error);
    });

// axios响应拦截响应拦截器
axios.interceptors.response.use(function(res) {
        // console.log("响应拦截：：" + res);
        // 判断登录状态是否过期
        if (res.data.result == 302) {
            //禁止缓存
            res.CacheControl = "no-cache";
            //删除cookie里面的user信息
            // cookie.delCookie("user");
            //跳转到登录页面
            router.push('/login/1');
        }
        return res;
    },
    function(error) {
        console.log(error);
        // 对响应错误做点什么
        return Promise.reject(error);

    });


// WEBPACK FOOTER //
// ./src/config/axios.js